import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Lightbulb, Loader2 } from "lucide-react";
import { http, fmtErr } from "../lib/api";

export default function CandyRequest() {
  const [form, setForm] = useState({ name: "", email: "", candy_name: "", description: "", why: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/candy-request", form);
      setDone(true);
      toast.success("Suggestion received!");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const input = "w-full bg-white border border-[#E5D8C1] px-4 py-3 focus:outline-none focus:border-[#D32F2F]";

  return (
    <div className="bg-[#FFFDF8]" data-testid="request-root">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="inline-flex items-center gap-2 bg-[#FFB300] text-[#1A1A1A] px-4 py-2 text-xs tracking-[0.3em] uppercase font-heading mb-4">
          <Lightbulb size={14} /> Community requested
        </div>
        <h1 className="font-heading text-6xl md:text-7xl uppercase tracking-wide leading-[0.95]">Request a candy.<br/><span className="text-[#D32F2F]">We might just make it.</span></h1>
        <p className="mt-6 text-lg text-[#5C5A56] max-w-2xl">Got a chamoy flavor idea burning in your brain? Drop it below. We read every suggestion — the ones that get requested most often become real chilito candies on the shelf.</p>

        {done ? (
          <div className="mt-10 bg-[#7CB342]/15 border border-[#7CB342] p-8" data-testid="request-success">
            <div className="font-heading text-2xl uppercase tracking-wide">Got it! 🌶</div>
            <p className="text-[#5C5A56] mt-2">Thanks for the idea. If it takes off we&apos;ll email you before it launches — plus a promo code as a thank-you.</p>
            <Link to="/shop" className="inline-block mt-6 border-2 border-[#1A1A1A] px-8 py-3 uppercase tracking-widest font-heading hover:bg-[#1A1A1A] hover:text-white">Shop while you wait</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 bg-[#FDF4E3] border border-[#E5D8C1] p-8 md:p-10 space-y-5">
            <label className="block"><span className="text-xs uppercase tracking-widest">Candy name / flavor idea *</span>
              <input required value={form.candy_name} onChange={(e) => setForm({...form, candy_name: e.target.value})} className={input + " mt-2"} placeholder="e.g. Chamoy Sour Belts / Pineapple Chile Cups" data-testid="request-candy-name" />
            </label>
            <label className="block"><span className="text-xs uppercase tracking-widest">Describe it</span>
              <textarea rows={3} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} className={input + " mt-2 resize-none"} placeholder="What is it? Texture? Base candy?" data-testid="request-description" />
            </label>
            <label className="block"><span className="text-xs uppercase tracking-widest">Why should we make it?</span>
              <textarea rows={3} value={form.why} onChange={(e) => setForm({...form, why: e.target.value})} className={input + " mt-2 resize-none"} placeholder="Would it sell? What crowd would love this?" data-testid="request-why" />
            </label>
            <div className="grid md:grid-cols-2 gap-5">
              <label className="block"><span className="text-xs uppercase tracking-widest">Your name *</span>
                <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className={input + " mt-2"} data-testid="request-name" />
              </label>
              <label className="block"><span className="text-xs uppercase tracking-widest">Email *</span>
                <input required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className={input + " mt-2"} placeholder="So we can tell you when it launches" data-testid="request-email" />
              </label>
            </div>
            <button type="submit" disabled={loading} className="w-full bg-[#D32F2F] text-white hover:bg-[#B71C1C] py-4 uppercase tracking-widest font-heading text-lg disabled:opacity-60 flex items-center justify-center gap-2 transition-transform hover:-translate-y-1" data-testid="request-submit">
              {loading && <Loader2 className="animate-spin" size={18} />} Submit suggestion
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
